import Axios from 'axios'
import {FacilityPricingTypeUrls} from './../urls'
import router from '../../../router'

export default {
  get_all_facility_pricing_types (context) {
    Axios.get(FacilityPricingTypeUrls.getAllFacility_pricing_types).then(function (response) {
      context.commit('GET_ALL_FACILITY_PRICING_TYPES', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_ALL_FACILITY_PRICING_TYPES', data)
    })
  },
  get_deleted_facility_pricing_types (context) {
    Axios.get(FacilityPricingTypeUrls.getDeletedFacility_pricing_types).then(function (response) {
      context.commit('GET_DELETED_FACILITY_PRICING_TYPES', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_DELETED_FACILITY_PRICING_TYPES', data)
    })
  },
  get_facilitypricingtype (context, publicId) {
    Axios.get(FacilityPricingTypeUrls.getFacilitypricingtype + publicId).then(function (response) {
      context.commit('GET_FACILITYPRICINGTYPE', response.data)
    }).catch(function () {
      var data = {data: []}
      context.commit('GET_FACILITYPRICINGTYPE', data)
    })
  },
  post_facilitypricingtype (context, data) {
    Axios.post(FacilityPricingTypeUrls.postFacilitypricingtype, data).then(function (response) {
      
      context.dispatch('get_all_facility_pricing_types')
    })
  },
  update_facilitypricingtype (context, data) {
    Axios.patch(FacilityPricingTypeUrls.editFacilitypricingtype, data).then(function (response) {
      context.dispatch('get_all_facility_pricing_types')
      router.push({
        name: data.redirect_url
      })
    })
  },
  delete_facilitypricingtype (context, data) {
    Axios.patch(FacilityPricingTypeUrls.deleteFacilitypricingtype, data).then(function (response) {
      context.dispatch('get_all_facility_pricing_types')
      context.commit('GET_DELETED_FACILITY_PRICING_TYPES', response.data)
      router.push({
        name: 'FacilitySettings'
      })
    })
  },
  restore_facilitypricingtype (context, publicId) {
    Axios.get(FacilityPricingTypeUrls.restoreFacilitypricingtype + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_FACILITY_PRICING_TYPES', response.data)
      router.push({
        name: 'Module.Facility_pricing_types'
      })
    })
  }
}
